import {
  enumOutboundTollingAgreementSortOption,
  OutboundTollingAgreementSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { outboundTollingAgreementsQueryAtom } from '../_graphql/queryOutboundTollingAgreements';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedProcessingType = atomFromQueryString.string('type');
export const $showInactive = atomFromQueryString.boolean('inactive', false);
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<OutboundTollingAgreementSortOption[]>([
  enumOutboundTollingAgreementSortOption.CreatedAtDesc,
]);

export const $remoteOutboundTollingAgreements =
  outboundTollingAgreementsQueryAtom((get) => {
    const searchTerm = get($searchTerm);
    const selectedProcessingType = get($selectedProcessingType);
    const showInactive = get($showInactive);
    const limit = get($limit);
    const offset = get($offset);
    const sorting = get($currentSorting);

    return {
      variables: {
        searchTerm: searchTerm || undefined,
        processingTypeIds:
          selectedProcessingType && selectedProcessingType !== 'all'
            ? [selectedProcessingType]
            : undefined,
        isActive: showInactive ? undefined : true,
        limit,
        offset,
        sorting,
      },
    };
  });
